export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-1920w.4076e6de.png";